import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { ErrorBoundaryProps } from '../../types/page';
import CustomButton from '../ui/buttons/Button';

type State = {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
        }
    }

    componentDidCatch(error: {}, errorInfo: {}) {
        // You can also log the error to an error reporting service
        const { applicationName, userId } = this.props;
        this.setState({ hasError: true });

        console.log({ error, errorInfo, applicationName, userId });
    }

    render() {
        const { hasError} = this.state;
        const { children } = this.props;

        if (hasError) {
            return (
                <Box className="error">
                    <Text fontSize='4xl' className='mb--0'>Something went wrong.</Text>
                    <Text color='gray.700' fontSize='lg' className='mb--10 mt--0'>
                        Please reload the page to continue using this app.
                    </Text>
                    <CustomButton
                        onClick={() => console.log('error button clicked')}
                        label="Report feedback"
                        cta='primary'
                        type='button'
                    />
				</Box>
            )
        } else {
            return children
        }
    }
}

export default ErrorBoundary;